import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { slot: "label" }
const _hoisted_2 = { class: "order-form__input-radio-label" }
const _hoisted_3 = { class: "order-form__input-radio-label" }
const _hoisted_4 = { class: "order-form__input-radio-label" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("y-input-wrapper", null, [
    _createElementVNode("label", _hoisted_1, _toDisplayString($setup.getTranslation('label_addressType')), 1 /* TEXT */),
    _createElementVNode("y-radio-button-group", null, [
      _createElementVNode("label", _hoisted_2, [
        _withDirectives(_createElementVNode("input", {
          type: "radio",
          name: "delivery-address",
          value: "home",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.deliveryAddressType) = $event))
        }, null, 512 /* NEED_PATCH */), [
          [_vModelRadio, $setup.deliveryAddressType]
        ]),
        _createElementVNode("span", null, _toDisplayString($setup.getTranslation('addressType_living')), 1 /* TEXT */)
      ]),
      _createElementVNode("label", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          type: "radio",
          name: "delivery-address",
          value: "company",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.deliveryAddressType) = $event))
        }, null, 512 /* NEED_PATCH */), [
          [_vModelRadio, $setup.deliveryAddressType]
        ]),
        _createElementVNode("span", null, _toDisplayString($setup.getTranslation('addressType_business')), 1 /* TEXT */)
      ]),
      _createElementVNode("label", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          type: "radio",
          name: "delivery-address",
          value: "funeralParlor",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.deliveryAddressType) = $event))
        }, null, 512 /* NEED_PATCH */), [
          [_vModelRadio, $setup.deliveryAddressType]
        ]),
        _createElementVNode("span", null, _toDisplayString($setup.getTranslation('addressType_funeral')), 1 /* TEXT */)
      ])
    ])
  ]))
}